module.exports = __webpack_public_path__ + "static/media/unchecked.94815ef9.svg";